import http, { apiErrorMessage } from '../../http';

const vRutaAutorizar = 'autorizar/';

// Listado de solicitudes de devolucion (modulo solo-matriz).
// estatus: PENDIENTE|AUTORIZADA|RECHAZADA|TODAS; fecha y guia opcionales.
export const getSolicitudesForTable = (estatus, fecha, guia) => {
    return (dispatch, getState) => {
        let params = { estatus };
        if (fecha) { params.fecha = fecha; }
        if (guia) { params.guia = guia; }
        http.get(vRutaAutorizar + 'solicitudes', { params })
            .then(function (response) {
                // Envelope v1 dataTable: {data:{rows:[...]}} -> la vista espera {data:[...]}
                dispatch({
                    type: "AUTORIZAR_LIST_SUCCESS", payload: {
                        data: { data: response.data.data.rows },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'AUTORIZAR_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

// Detalle completo de una solicitud (snapshot de la entrega original incluido).
export const getSolicitudDetalle = (id) => {
    return (dispatch, getState) => {
        http.get(vRutaAutorizar + 'solicitudes/' + id)
            .then(function (response) {
                // Envelope v1 ANIDADO: {data:{solicitud:{id,guia,tipo,...,fotos_nuevas,anterior:{fecha,recibe,
                // relacion_recibe,motivo_sin_firma,lat,lon,observaciones,fotos,tiene_firma}},
                // guia:{...}, reparto:{...}, puede_autorizar:bool, motivo_bloqueo:string|null}}
                // -> se aplana al shape PLANO que lee la vista (campos ant_* + fotos_anteriores, etc.;
                //    'tipo' REVERSION|DIRECTA viene dentro de solicitud y queda en el plano via el spread)
                const d = response.data.data;
                const s = d.solicitud || {};
                const ant = s.anterior || {};
                const detalle = {
                    ...s,
                    ant_fecha: ant.fecha,
                    ant_recibe: ant.recibe,
                    ant_relacion_recibe: ant.relacion_recibe,
                    ant_motivo_sin_firma: ant.motivo_sin_firma,
                    ant_lat: ant.lat,
                    ant_lon: ant.lon,
                    ant_observaciones: ant.observaciones,
                    fotos_anteriores: ant.fotos,
                    tiene_firma_anterior: ant.tiene_firma,
                    puede_autorizar: d.puede_autorizar,
                    motivo_bloqueo: d.motivo_bloqueo,
                };
                dispatch({
                    type: "AUTORIZAR_DETALLE_SUCCESS", payload: {
                        data: { resultado: detalle },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'AUTORIZAR_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

// Resuelve una solicitud: accion 'autorizar'|'rechazar' + comentario opcional.
export const resolverSolicitud = (id, accion, comentario) => {
    return (dispatch, getState) => {
        http.post(vRutaAutorizar + 'solicitudes/' + id + '/resolver', { accion, comentario })
            .then(function (response) {
                // Envelope v1: {data:{resultado:'AUTORIZADA'|'RECHAZADA'}}
                dispatch({
                    type: "AUTORIZAR_RESOLVER_SUCCESS", payload: {
                        data: { resultado: response.data.data.resultado },
                    }
                });
            })
            .catch(function (error) {
                // Incluye el 409 de cierre automatico: se muestra el mensaje del API
                dispatch({ type: 'AUTORIZAR_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

// Consulta integral de una guia: maestra + entregas EAD + seguimiento + solicitudes.
export const consultarGuia = (guia) => {
    return (dispatch, getState) => {
        http.get(vRutaAutorizar + 'guias/' + encodeURIComponent(guia))
            .then(function (response) {
                // Envelope v1: {data:{guia,entregas,seguimiento,solicitudes}} -> la vista lee .resultado
                dispatch({
                    type: "AUTORIZAR_GUIA_SUCCESS", payload: {
                        data: { resultado: response.data.data },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'AUTORIZAR_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

export const limpiarDetalle = () => {
    return (dispatch, getState) => {
        dispatch({ type: "AUTORIZAR_LIMPIAR_DETALLE" });
    }
}

export const limpiarResolver = () => {
    return (dispatch, getState) => {
        dispatch({ type: "AUTORIZAR_LIMPIAR_RESOLVER" });
    }
}

export const limpiarGuia = () => {
    return (dispatch, getState) => {
        dispatch({ type: "AUTORIZAR_LIMPIAR_GUIA" });
    }
}

export const closeMessages = () => {
    return (dispatch, getState) => {
        dispatch({ type: "AUTORIZAR_CLOSE_MESSAGES" });
    }
}
